import React from 'react';
import { Provider } from 'mobx-react';
import { stores } from './src/store';

export default ({ element }) => {
  return <Provider {...stores}>{element}</Provider>;
};
